import {
  IconBell,
  IconChat,
  IconConnectedAccounts,
  IconDoc,
  IconLogout,
  IconNews,
  IconPerson,
  IconQuestionCircle,
  useResponsive,
} from '@bitrise/bitkit-v2';
import { Separator } from '@chakra-ui/react/separator';
import { Text } from '@chakra-ui/react/text';
import { useCallback, useContext } from 'react';

import Dot from '@/components/Dot/Dot';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import URLs from '@/enums/urls';
import useChangelog from '@/hooks/useChangelog';
import { useLastUsedEmail } from '@/hooks/useLastUsedEmail';
import { UserContext } from '@/models/User';

import LinkItem from './LinkItem';

const AccountDrawer = ({ user }: { user: UserContext }) => {
  const { isMobile } = useResponsive();
  const { account } = useContext(GlobalPropsContext);
  const [, , clearSSOEmail] = useLastUsedEmail();

  const { hasUnreadTopics: changelogHasUnreadTopics } = useChangelog();

  const logout = useCallback(() => {
    window.Intercom?.('shutdown');
    window.location.href = '/users/sign_out';
    clearSSOEmail();
  }, [clearSSOEmail]);

  return (
    <>
      <Text paddingX="24">{user.email}</Text>
      <Separator marginY="24" />
      <LinkItem icon={IconPerson} href="/me/account">
        Account settings
      </LinkItem>
      <LinkItem icon={IconConnectedAccounts} href="/me/account/connected-accounts">
        Connected accounts
      </LinkItem>
      {isMobile && (
        <>
          {account && (
            <LinkItem icon={IconBell} href="/activity">
              Notifications
            </LinkItem>
          )}
          <Separator marginY="24" />
          <Text textStyle="heading/h6" color="text/tertiary" paddingX="24" marginBottom="8">
            Help
          </Text>
          <LinkItem icon={IconNews} href={URLs.CHANGELOG} position="relative">
            {changelogHasUnreadTopics && (
              <Dot size="8" backgroundColor="icon/negative" position="absolute" top="12" left="40" />
            )}
            Changelog
          </LinkItem>
          <LinkItem icon={IconDoc} isExternal href={URLs.DOCUMENTATION} title="Answers to your questions">
            Documentation
          </LinkItem>
          <LinkItem icon={IconChat} isExternal href={URLs.COMMUNITY_FORUM} title="Ask your fellow developers">
            Community forum
          </LinkItem>
          <LinkItem icon={IconQuestionCircle} isExternal href={URLs.SUPPORT_CENTER} title="Support center">
            Support Center
          </LinkItem>
        </>
      )}
      <Separator marginY="24" />
      <LinkItem icon={IconLogout} onClick={logout}>
        Logout
      </LinkItem>
    </>
  );
};

export default AccountDrawer;
